import { VARIABLE_PREFIX } from '../index';

export const indexReplacement = (idxVar: string): string => {
  return `${VARIABLE_PREFIX}${idxVar}`;
};
